// PageProdutos.jsx
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../Integration/Header';
import BarraMenu from '../Integration/BarraMenu';
import FooterMenu from '../Integration/FooterMenu';
import FbGetProduct from '../../Middleware/Firebase/FbGetProduct';
import FootPageNumber from '../Integration/FootPageNumber';
import '../../Css/menuproductos.css';

export default function PageProdutos() {
  const location = useLocation();

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(30); // você já usava 30
  const [totalItems, setTotalItems] = useState(0);

  // Sempre que a rota mudar (categoria/coleção), volte para página 1
  useEffect(() => {
    setCurrentPage(1);
  }, [location.pathname]);

  return (
    <div className="page-produto">
      <Header />
      <BarraMenu />
      <main className="produto-wrapper">
        <FbGetProduct
          pageSize={pageSize}
          currentPage={currentPage}
          onTotalChange={setTotalItems}
        />
      </main>

      <FootPageNumber
        totalItems={totalItems}
        pageSize={pageSize}
        currentPage={currentPage}
        onPageChange={setCurrentPage}
      />

      <FooterMenu />
    </div>
  );
}